var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Control, controlsUtils, FabricImage, loadSVGFromString, Textbox, util, } from 'fabric';
import { CANVAS_OBJECT_ADDED } from '../Rutab/RutabConstants';
import fontFamilyOptions from '../Components/Editor/Utils/FontFamilyOptions';
import { uploadImage } from '../Actions/Rutab/DecalEditor.action';
export const getCanvasCenter = (canvas) => {
    const zoomLevel = canvas.getZoom();
    const canvasCenterX = canvas.width / zoomLevel / 2;
    const canvasCenterY = canvas.height / zoomLevel / 2;
    return { canvasCenterX, canvasCenterY };
};
export const textStyles = {
    header: {
        fontSize: 48,
        fontWeight: 'bold',
    },
    subheader: {
        fontSize: 36,
        fontWeight: 'bold',
    },
    body: {
        fontSize: 24,
        fontWeight: 'normal',
    },
    default: {
        fontSize: 38,
        fontWeight: 'normal',
    },
};
export const addText = (canvas, style = 'default') => (dispatch) => {
    var _a, _b;
    if (canvas) {
        const { canvasCenterX, canvasCenterY } = getCanvasCenter(canvas);
        const styleProps = textStyles[style];
        const textbox = new Textbox('Hej!', Object.assign(Object.assign({}, styleProps), { opacity: 1, fill: '#000000', id: 'text', objectCaching: false, noScaleCache: false, fontFamily: (_b = (_a = fontFamilyOptions.find((font) => font.default)) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : 'Arial', borderColor: 'none', cornerColor: '#112d61', cornerSize: 12, cornerStyle: 'circle', transparentCorners: false, padding: 0, textAlign: 'left', top: canvasCenterY - styleProps.fontSize / 2, centeredScaling: true, breakWords: true, wordWrap: true, lineHeight: 1 }));
        textbox.set({
            left: canvasCenterX - textbox.width / 2,
        });
        setVisibilityControlsForObject(textbox);
        overrideRotationControl(textbox);
        canvas.add(textbox);
        canvas.setActiveObject(textbox);
        textbox.enterEditing();
        canvas.renderAll();
        dispatch({
            type: CANVAS_OBJECT_ADDED,
        });
    }
};
export const addImage = (canvas, imageSource, canvasSize, systemId) => __awaiter(void 0, void 0, void 0, function* () {
    if (!canvas)
        return;
    let imageUrl;
    if (imageSource instanceof File) {
        const uploadResponse = yield uploadImage(imageSource);
        imageUrl = uploadResponse.imageSrc;
        systemId = uploadResponse.systemId;
    }
    else {
        imageUrl = imageSource;
    }
    yield loadImageToCanvas(canvas, imageUrl, canvasSize, systemId);
});
export const addIcon = (canvas, svg) => __awaiter(void 0, void 0, void 0, function* () {
    if (!canvas)
        return;
    try {
        const { objects, options } = yield loadSVGFromString(svg);
        const obj = util.groupSVGElements(objects, options);
        const { canvasCenterX, canvasCenterY } = getCanvasCenter(canvas);
        obj.set({
            left: canvasCenterX,
            top: canvasCenterY,
            objectCaching: false,
            noScaleCache: false,
            borderColor: 'none',
            cornerColor: '#112d61',
            cornerSize: 12,
            cornerStyle: 'circle',
            transparentCorners: false,
            centeredScaling: true,
            id: 'icon',
        });
        setVisibilityControlsForObject(obj);
        overrideRotationControl(obj);
        canvas.add(obj);
        canvas.setActiveObject(obj);
        canvas.renderAll();
    }
    catch (error) {
        console.error('Error loading SVG to canvas:', error);
    }
});
export function setVisibilityControlsForObject(object) {
    object.setControlsVisibility({
        mt: false,
        mb: false,
        mtr: true,
    });
}
export function overrideRotationControl(object) {
    const rotationIconSVG = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"/>
  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"/>
</svg>
    `;
    const rotationIconURL = 'data:image/svg+xml;base64,' + window.btoa(rotationIconSVG);
    const rotationIcon = new Image();
    rotationIcon.src = rotationIconURL;
    const icon = new Image();
    icon.src = rotationIconURL;
    object.controls.mtr = new Control({
        x: 0,
        y: 0.5,
        offsetY: 30,
        cursorStyle: `crosshair`,
        actionHandler: controlsUtils.rotationWithSnapping,
        actionName: 'rotate',
        withConnection: false,
        sizeX: 40,
        sizeY: 40,
        render: (ctx, left, top, styleOverride, fabricObject) => {
            const size = 39;
            ctx.save();
            ctx.translate(left, top);
            ctx.rotate(util.degreesToRadians(fabricObject.angle));
            ctx.drawImage(icon, -size / 2, -size / 2, size, size);
            ctx.restore();
        },
    });
}
export const loadImageToCanvas = (canvas, imageUrl, canvasSize, systemId) => __awaiter(void 0, void 0, void 0, function* () {
    if (!canvas)
        return;
    try {
        const image = yield FabricImage.fromURL(imageUrl);
        const { canvasCenterX, canvasCenterY } = getCanvasCenter(canvas);
        const originalWidth = image.width;
        const originalHeight = image.height;
        const canvasPhysicalWidthMM = canvasSize.width;
        const canvasPhysicalHeightMM = canvasSize.height;
        image.set({
            left: canvasCenterX,
            top: canvasCenterY,
            objectCaching: false,
            noScaleCache: false,
            borderColor: 'none',
            cornerColor: '#112d61',
            cornerSize: 12,
            cornerStyle: 'circle',
            transparentCorners: false,
            centeredScaling: true,
            systemId: systemId,
        });
        setVisibilityControlsForObject(image);
        overrideRotationControl(image);
        const scale = calculateOptimalImageScale(originalWidth, originalHeight, canvasPhysicalWidthMM, canvasPhysicalHeightMM, canvas.width, canvas.height);
        image.scale(scale);
        canvas.add(image);
        canvas.setActiveObject(image);
        canvas.renderAll();
    }
    catch (error) {
        console.error('Error loading image to canvas:', error);
    }
});
export const calculateRecommendedScale = (imageWidthPx, imageHeightPx, canvasWidthMM, canvasHeightMM, targetDPMM = 11.81) => {
    const requiredWidthPx = canvasWidthMM * targetDPMM;
    const requiredHeightPx = canvasHeightMM * targetDPMM;
    const scaleX = requiredWidthPx / imageWidthPx;
    const scaleY = requiredHeightPx / imageHeightPx;
    return Math.min(scaleX, scaleY);
};
export const getImageQuality = (imageWidthPx, imageHeightPx, canvasWidthMM, canvasHeightMM, scale = 1) => {
    const effectiveWidthPx = imageWidthPx * scale;
    const effectiveHeightPx = imageHeightPx * scale;
    // Eller om man vill ha en dpmm som är samma för både bredd och höjd
    // const dpmmX = effectiveWidthPx / canvasWidthMM;
    // const dpmmY = effectiveHeightPx / canvasHeightMM;
    // const dpmm = Math.min(dpmmX, dpmmY);
    // Denna tar hänsyn till om bilden är i porträtt eller landskap, vi kör på denna så Ida kan se vad som är bäst
    const canvasIsPortrait = canvasHeightMM > canvasWidthMM;
    const imageIsPortrait = imageHeightPx > imageWidthPx;
    const effectiveWidth = imageIsPortrait === canvasIsPortrait ? effectiveWidthPx : effectiveHeightPx;
    const effectiveHeight = imageIsPortrait === canvasIsPortrait ? effectiveHeightPx : effectiveWidthPx;
    const logicalCanvasWidth = canvasIsPortrait === imageIsPortrait ? canvasWidthMM : canvasHeightMM;
    const logicalCanvasHeight = canvasIsPortrait === imageIsPortrait ? canvasHeightMM : canvasWidthMM;
    const dpmmX = effectiveWidth / logicalCanvasWidth;
    const dpmmY = effectiveHeight / logicalCanvasHeight;
    const dpmm = (dpmmX + dpmmY) / 2;
    const HIGH_QUALITY_DPMM = 11.81; //  300 DPI (300 / 25.4)
    const MINIMUM_QUALITY_DPMM = 5.91; //  150 DPI (150 / 25.4)
    const minWidthPx = Math.ceil(MINIMUM_QUALITY_DPMM * canvasWidthMM);
    const minHeightPx = Math.ceil(MINIMUM_QUALITY_DPMM * canvasHeightMM);
    const highQualityWidthPx = Math.ceil(HIGH_QUALITY_DPMM * canvasWidthMM);
    const highQualityHeightPx = Math.ceil(HIGH_QUALITY_DPMM * canvasHeightMM);
    const minimumScale = calculateRecommendedScale(imageWidthPx, imageHeightPx, canvasWidthMM, canvasHeightMM, MINIMUM_QUALITY_DPMM);
    const highQualityScale = calculateRecommendedScale(imageWidthPx, imageHeightPx, canvasWidthMM, canvasHeightMM, HIGH_QUALITY_DPMM);
    let qualityLevel;
    let qualityWarning = null;
    if (dpmm >= HIGH_QUALITY_DPMM) {
        qualityLevel = 'high';
    }
    else if (dpmm >= MINIMUM_QUALITY_DPMM) {
        qualityLevel = 'medium';
        qualityWarning = `Notis: Bildens upplösning (${Math.round(dpmm * 10) / 10} pixlar/mm) är under den rekommenderade nivån på 12 pixlar/mm för högkvalitativ utskrift. Den kan se något suddig ut vid utskrift på ${canvasWidthMM}mm x ${canvasHeightMM}mm.
    
För bästa kvalitet, använd en bild med minst ${highQualityWidthPx}px × ${highQualityHeightPx}px, eller skala upp bilden till ${Math.round(highQualityScale * 100)}% av dess nuvarande storlek.`;
    }
    else {
        qualityLevel = 'low';
        qualityWarning = `Varning: Bildens upplösning är för låg (${Math.round(dpmm * 10) / 10} pixlar/mm). Den kan se pixlig ut vid utskrift på ${canvasWidthMM}mm x ${canvasHeightMM}mm. 
    
För bättre kvalitet, använd en bild med minst ${minWidthPx}px × ${minHeightPx}px, eller skala upp bilden till ${Math.round(minimumScale * 100)}% av dess nuvarande storlek.
För bästa kvalitet, använd en bild med minst ${highQualityWidthPx}px × ${highQualityHeightPx}px, eller skala upp bilden till ${Math.round(highQualityScale * 100)}% av dess nuvarande storlek.`;
    }
    return {
        dpmm,
        dpmmX,
        dpmmY,
        dpi: dpmm * 25.4,
        qualityLevel,
        qualityWarning,
        effectiveWidthPx,
        effectiveHeightPx,
        currentScale: scale,
        recommendedScales: {
            minimum: minimumScale,
            highQuality: highQualityScale,
        },
        recommendedSizes: {
            minimum: {
                width: minWidthPx,
                height: minHeightPx,
                dpmm: MINIMUM_QUALITY_DPMM,
                dpi: MINIMUM_QUALITY_DPMM * 25.4,
            },
            highQuality: {
                width: highQualityWidthPx,
                height: highQualityHeightPx,
                dpmm: HIGH_QUALITY_DPMM,
                dpi: HIGH_QUALITY_DPMM * 25.4,
            },
        },
    };
};
export const calculateOptimalImageScale = (imageWidthPx, imageHeightPx, canvasWidthMM, canvasHeightMM, canvasWidthPx, canvasHeightPx, minQualityDPMM = 5.91) => {
    const scaleX = canvasWidthMM / imageWidthPx;
    const scaleY = canvasHeightMM / imageHeightPx;
    return Math.max(scaleX, scaleY);
};
export const resizeImageToRecommendedQuality = (canvas, imageObject, canvasWidthMM, canvasHeightMM, preferHighQuality = false) => {
    if (!canvas || !imageObject || !imageObject.width || !imageObject.height) {
        return null;
    }
    const originalWidth = imageObject.width;
    const originalHeight = imageObject.height;
    const currentScale = imageObject.scaleX || 1;
    const qualityInfo = getImageQuality(originalWidth, originalHeight, canvasWidthMM, canvasHeightMM, currentScale);
    if ((preferHighQuality && qualityInfo.qualityLevel === 'high') ||
        (!preferHighQuality &&
            (qualityInfo.qualityLevel === 'medium' ||
                qualityInfo.qualityLevel === 'high'))) {
        return qualityInfo;
    }
    const targetScale = preferHighQuality
        ? qualityInfo.recommendedScales.highQuality
        : qualityInfo.recommendedScales.minimum;
    if (targetScale > currentScale) {
        const center = imageObject.getCenterPoint();
        imageObject.scale(targetScale);
        imageObject.setPositionByOrigin(center, 'center', 'center');
        canvas.renderAll();
        return getImageQuality(originalWidth, originalHeight, canvasWidthMM, canvasHeightMM, targetScale);
    }
    return qualityInfo;
};
